import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import { Link } from "react-router-dom";
import Leftpanel from "../../layout/Leftpanel";
import { getAllCo2list } from "../../../../service/co2/co2Service";
import instance from "../../../../WebApi/WebApi";
import SpinnerComponent from "../../../components/SpinnerComponent";
import ReactPaginate from "react-paginate";
import { useTranslation } from "react-i18next";

const Co2 = () => {
  const { t } = useTranslation();
  const [co2List, setAllCo2List] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const PER_PAGE = 10;

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const offset = currentPage * PER_PAGE;
  const currentPageData = co2List.slice(offset, offset + PER_PAGE);

  const pageCount = Math.ceil(co2List?.length / PER_PAGE);

  useEffect(() => {
    getCo2DataList();
  }, []);

  async function getCo2DataList() {
    setIsLoading(true);
    getAllCo2list().then(function (result) {
      console.log(result.data, "datadatadatadatada");
      const response = result.data;
      console.log(response, "rrrr");
      setAllCo2List(response.data?.listCo2Measurement);
      setIsLoading(false);
    });
  }
  const onSearch = async (e) => {
    setSearch(e.target.value);
    const searchText = e.target.value;
    setIsLoading(true);
    try {
      const response = await instance(
        `/customer/co2-measurement/list-co2-measurement?searchKeyword=${searchText}`
      );
      setAllCo2List(response.data?.data?.listCo2Measurement);
      setIsLoading(false);
      console.log("resp-->", response);
    } catch (err) {
      setIsLoading(false);
      console.log("err->", err);
    }
  };

  return (
    <div className="container-fluid">
      <div className="dbMain co2bg">
        <Leftpanel breadcm="Other" />
        <div className="dbRight">
          <Header link="/dashboard" title={t("co2e_emission")} description="" />

          <div className="commonBase mb-4">
            <div className="dbMaintable co2Table respTable">
              <div className="dbSearch" style={{ width: "40%" }}>
                <input
                  type="search"
                  className="form-control"
                  placeholder={t("search")}
                  onChange={onSearch}
                  value={search}
                />
                <i className="fa-solid fa-magnifying-glass"></i>
              </div>
              <table>
                <thead>
                  <tr>
                    <th>{t("product_type")}</th>
                    <th>{t("product_name")}</th>
                    <th>{t("base_unit")}</th>
                    <th>{t("co2e_unit")}</th>
                    <th>{t("co2e_kg")}</th>
                    <th>{t("unspsc_code")}</th>
                    <th>{t("stakeholder")}</th>
                    <th>{t("manufacturer")}</th>
                  </tr>
                </thead>
                {isLoading && <SpinnerComponent isLoading={isLoading} />}
                <tbody>
                  {currentPageData?.map((d) => (
                    <tr key={d.id}>
                      {" "}
                      {/* Ensure each item has a unique key */}
                      <td data-label={t("product_type")}>{d?.type}</td>
                      <td data-label={t("product_name")}>{d?.name}&nbsp;</td>
                      <td data-label={t("base_unit")}>{d?.baseUnit}&nbsp;</td>
                      <td data-label={t("co2e_unit")}>{d?.CO2Unit}&nbsp;</td>
                      <td data-label={t("co2e_kg")}>{d?.CO2KG}&nbsp;</td>
                      <td data-label={t("unspsc_code")}>
                        {d?.UNSPSC_Code?.Class}&nbsp;
                      </td>
                      <td data-label={t("stakeholder_source")}>
                        {d?.stakeholder}&nbsp;
                      </td>
                      <td data-label={t("manufacturer_source")}>
                        {d?.manufacturer}&nbsp;
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {!isLoading && (
              <ReactPaginate
                previousLabel={t("previous")}
                nextLabel={t("next")}
                pageCount={pageCount}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                previousLinkClassName={"pagination__link"}
                nextLinkClassName={"pagination__link"}
                disabledClassName={"pagination__link--disabled"}
                activeClassName={"pagination__link--active"}
                forcePage={currentPage}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Co2;
